<template>
    <div class="max-w-7xl mx-auto md:px-6 md:mt-4">
        <div class="bg-white p-6 shadow border-b border-gray-200 md:rounded-lg">
            <slot></slot>
        </div>
    </div>
</template>

<script>
export default {
    name: "PageContent"
}
</script>